// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","223":"commons","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"be5c7949a7f596ee02fd","223":"a4bf82e0f75cd2c6eb97","293":"0cfd6f8c3675f4e36211","454":"2980f87c17f26afd343c"}[chunkId] + ".js";
};